import React from "react";
import "./SkillsInfo.css";

const EInfo = () => {
  return (
    <>
      <p className="skill__key">E</p>
      <h5 className="skill_name">AEGIS ASSAULT</h5>
      <p className="skill_infos">
        Pantheon sets his shield, becoming invulnerable to damage from the front
        and striking repeatedly with his spear.
      </p>
    </>
  );
};

export default EInfo;
